
/**
 * ONLY for front end checking on Uploading raw file restrictions
 * Included in this list
 * Users will be able to upload raw files with no number or file size restrictions
 * data format: array ['email@address']
 */
export const priviledgedUsers = [
  'steffen.yde.bak@dupont.com',
  'bliao@uottawa.ca',
];